import { FC, Fragment, memo, useEffect } from "react";
import { FormikHandlers } from "formik";
import {
  AutocompleteFilterBody,
  AutocompleteFilterBodyProps,
} from "../AutocompleteFilterBody";
import {
  FilterItem,
  Operator,
  ResourceType,
  usePostUsersMeDynamoDbBackupTableNamesMutation,
} from "../../../../../../../../services/cloudchipr.api";
import { FilterItemOperatorType } from "../../../FilterItemOperatorType";

interface TableNamesFilterProps extends AutocompleteFilterBodyProps {
  accountIds?: string[];
  resourceType: ResourceType;
  filter: FilterItem;
  operators?: Operator[];
  onChange: FormikHandlers["handleChange"];
}

export const TableNamesFilter: FC<TableNamesFilterProps> = memo(
  ({ resourceType, accountIds, operators, filter, onChange, ...props }) => {
    const [trigger, { data, isLoading }] =
      usePostUsersMeDynamoDbBackupTableNamesMutation();

    useEffect(() => {
      if (!accountIds) {
        return;
      }
      trigger({
        body: { account_ids: accountIds },
      });
    }, [resourceType, accountIds, trigger]);

    return (
      <Fragment>
        <FilterItemOperatorType
          onChange={onChange}
          options={operators}
          value={filter.operator || "in"}
        />

        <AutocompleteFilterBody
          {...props}
          options={data ?? []}
          isLoading={isLoading}
          label="Tables"
          selectedValue={Array.isArray(filter?.value) ? filter.value : []}
        />
      </Fragment>
    );
  },
);
